const formatCurrency = (num, currencyCode, options = {}) => {
  const { noSymbol = false, currencyDisplayDefault = 'symbol' } = options;
  const value = Number(num) || 0;
  return value.toLocaleString('es-AR', {
    style: noSymbol ? 'decimal' : 'currency',
    currency: currencyCode,
    currencyDisplay: noSymbol ? undefined : currencyDisplayDefault,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const currency = (
  num,
  isInUSD = false,
  noSymbol = false,
  customCurrency = null
) => {
  if (customCurrency) {
    return formatCurrency(num, customCurrency, {
      noSymbol,
      currencyDisplayDefault: 'code',
    });
  }
  if (isInUSD) {
    return formatCurrency(num, 'USD', {
      noSymbol,
      currencyDisplayDefault: 'code',
    });
  }
  return formatCurrency(num, 'ARS', {
    noSymbol,
    currencyDisplayDefault: 'symbol',
  });
};
